import { apiClient } from '../client'
import type { DNSType } from '../../app/modules/types/dns'
import type { SmtpType } from '../../app/modules/types/smtp'
import type { ServiceType } from '../../app/modules/types/service'

/**
 * Tools API endpoints
 */
export const toolsApi = {
  /**
   * Get tools list
   */
  getList: async (): Promise<any> => {
    const { data } = await apiClient.get('/tools/')
    return data
  },

  /**
   * Get tool by ID
   */
  getById: async (toolId: string): Promise<any> => {
    const { data } = await apiClient.get(`/tools/${toolId}/`)
    return data
  },

  /**
   * Execute tool
   */
  execute: async (toolId: string, payload: any): Promise<any> => {
    const { data } = await apiClient.post(`/tools/${toolId}/execute/`, payload)
    return data
  },

  /**
   * Get DNS data
   */
  getDns: async (params?: string): Promise<any> => {
    const url = params ? `/dns/${params}` : '/dns/'
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get SMTP data
   */
  getSmtp: async (params?: string): Promise<any> => {
    const url = params ? `/smtp/?${params}` : '/smtp/'
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get services/features
   */
  getServices: async (params?: string): Promise<ServiceType[]> => {
    const url = params ? `/features/${params}` : '/features/'
    const { data } = await apiClient.get(url)
    return data
  },
}
